"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _antd = require("antd");
var _react = _interopRequireWildcard(require("react"));
var _useDebouncy = require("use-debouncy");
var _ColorPicker = _interopRequireDefault(require("../ColorPicker"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ComponentTokenInput = function ComponentTokenInput(_ref) {
  var theme = _ref.theme,
    token = _ref.token,
    component = _ref.component,
    color = _ref.color,
    children = _ref.children,
    value = _ref.value,
    style = _ref.style,
    className = _ref.className;
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    tokenValue = _useState2[0],
    setTokenValue = _useState2[1];
  var onThemeChange = function onThemeChange(newValue) {
    var _theme$onThemeChange, _theme$config$compone, _theme$config, _theme$config2;
    (_theme$onThemeChange = theme.onThemeChange) === null || _theme$onThemeChange === void 0 || _theme$onThemeChange.call(theme, _objectSpread(_objectSpread({}, theme.config), {}, {
      components: _objectSpread(_objectSpread({}, (_theme$config$compone = (_theme$config = theme.config) === null || _theme$config === void 0 ? void 0 : _theme$config.components) !== null && _theme$config$compone !== void 0 ? _theme$config$compone : {}), {}, (0, _defineProperty2.default)({}, component, _objectSpread(_objectSpread({}, (_theme$config2 = theme.config) === null || _theme$config2 === void 0 || (_theme$config2 = _theme$config2.components) === null || _theme$config2 === void 0 ? void 0 : _theme$config2[component]), {}, (0, _defineProperty2.default)({}, token, newValue))))
    }), ['components', component, token]);
  };
  var debouncedOnChange = (0, _useDebouncy.useDebouncyFn)(onThemeChange, 200);
  (0, _react.useEffect)(function () {
    setTokenValue(value);
  }, [value]);
  var handleChange = function handleChange(newValue) {
    setTokenValue(newValue);
    debouncedOnChange(newValue);
  };
  var child = /*#__PURE__*/_react.default.createElement("span", {
    style: style,
    className: className
  }, children);
  if (color) {
    return /*#__PURE__*/_react.default.createElement(_ColorPicker.default, {
      placement: "bottomRight",
      value: tokenValue,
      onChangeComplete: function onChangeComplete(newColor) {
        onThemeChange(newColor.toRgbString());
      }
    }, child);
  }
  var inputNode;
  if (typeof tokenValue === 'string') {
    inputNode = /*#__PURE__*/_react.default.createElement(_antd.Input, {
      value: tokenValue,
      onChange: function onChange(e) {
        return handleChange(e.target.value);
      }
    });
  } else if (typeof tokenValue === 'number') {
    inputNode = /*#__PURE__*/_react.default.createElement(_antd.InputNumber, {
      style: {
        minWidth: 200
      },
      value: tokenValue,
      onChange: function onChange(newValue) {
        return handleChange(newValue !== null && newValue !== void 0 ? newValue : 0);
      }
    });
  } else if (typeof tokenValue === 'boolean') {
    inputNode = /*#__PURE__*/_react.default.createElement(_antd.Switch, {
      checked: tokenValue,
      onChange: function onChange(checked) {
        return handleChange(checked);
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement(_antd.Popover, {
    trigger: "click",
    placement: "bottomRight",
    content: inputNode
  }, child);
};
var _default = exports.default = ComponentTokenInput;